import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AccountAdminGuard } from "../shared/guards/accountAdminGuard.guard";

const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "pbx-overview",
        runGuardsAndResolvers: "always",
        loadChildren: () =>
          import("./pbxOverview/pbx-overview.module").then(m => m.PbxOverviewModule),
        data: { title: "PBX Overview" }
      },
      {
        path: "pbx-settings",
        runGuardsAndResolvers: "always",
        loadChildren: () =>
          import("./pbx-settings/pbx-settings.module").then(m => m.PbxSettingsModule),
        data: { title: "PBX settings" }
      },
      {
        path: "dbn-directory",
        runGuardsAndResolvers: "always",
        loadChildren: () =>
          import("./dbnDirectory/dbn-directory.module").then(m => m.DbnDirectoryModule),
        data: { title: "Dial-by-name directory" }
      },
      {
        path: "voicemail",
        loadChildren: () =>
          import("./voicemail/admin-voicemail.module").then(m => m.AdminVoicemailModule)
      },
      {
        path: "e911",
        runGuardsAndResolvers: "always",
        canActivate: [AccountAdminGuard],
        loadChildren: () => import("./e911/admin-e911.module").then(m => m.AdminE911Module),
        data: { title: "E911" }
      },
      {
        path: "phone-numbers",
        runGuardsAndResolvers: "always",
        canActivate: [AccountAdminGuard],
        loadChildren: () =>
          import("./phoneNumbers/admin-phone-numbers.module").then(m => m.AdminPhoneNumbersModule),
        data: { title: "Phone Numbers" }
      },
      {
        path: "music-on-hold",
        runGuardsAndResolvers: "always",
        canActivate: [AccountAdminGuard],
        loadChildren: () =>
          import("./musicOnHold/music-on-hold.module").then(m => m.MusicOnHoldModule),
        data: { title: "Music On Hold" }
      },
      {
        path: "recording-library",
        loadChildren: () =>
          import("./recording/recording.module").then(m => m.AdminRecordingModule),
        data: { title: "Recording library" }
      },
      {
        path: "reports",
        runGuardsAndResolvers: "always",
        canActivate: [AccountAdminGuard],
        loadChildren: () => import("./reports/reports.module").then(m => m.ReportsModule),
        data: { title: "Reports" }
      },
      {
        path: "groups",
        loadChildren: () => import("./groups/groups.module").then(m => m.GroupsModule),
        data: { title: "Groups" }
      },
      {
        path: "users",
        loadChildren: () => import("./adminUsers/admin-users.module").then(m => m.AdminUsersModule),
        data: { title: "Team Settings" }
      },
      {
        path: "phones",
        loadChildren: () => import("./phones/phones.module").then(m => m.PhonesModule),
        data: { title: "Phones" }
      },
      {
        path: "announcements",
        loadChildren: () =>
          import("./announcements/announcements.module").then(m => m.AnnouncementsModule),
        data: { title: "Announcements" }
      },
      {
        path: "business-hour-rules",
        loadChildren: () =>
          import("./businessHourRules/business-hour-rules.module").then(
            m => m.BusinessHourRulesModule
          ),
        data: { title: "Business hour rules" }
      },
      {
        path: "attendant-menu",
        data: { title: "Attendant menu" },
        runGuardsAndResolvers: "always",
        loadChildren: () =>
          import("./attendantMenu/attendant-menu.module").then(m => m.AttendantMenuModule)
      },
      {
        path: "parking-lot",
        data: { title: "Parking lot" },
        runGuardsAndResolvers: "always",
        loadChildren: () => import("./parkingLot/parking-lot.module").then(m => m.ParkingLotModule)
      },
      {
        path: "inbound-bridge",
        data: { title: "Inbound Bridge" },
        loadChildren: () =>
          import("./inboundBridge/inbound-bridge.module").then(m => m.InboundBridgeModule)
      },
      {
        path: "acd-queues",
        data: { title: "ACD queues" },
        runGuardsAndResolvers: "always",
        loadChildren: () => import("./acdQueues/acd-queues.module").then(m => m.AcdQueuesModule)
      },
      {
        path: "external-address",
        data: { title: "External Sip Address" },
        runGuardsAndResolvers: "always",
        loadChildren: () =>
          import("./externalSipAddress/external-sip-address.module").then(
            m => m.ExternalSipAddressModule
          )
      },
      {
        path: "directory",
        data: { title: "Directory" },
        runGuardsAndResolvers: "always",
        loadChildren: () => import("./directory/directory.module").then(m => m.DirectoryModule)
      },
      {
        path: "recording-rules",
        data: { title: "Recording Rules" },
        runGuardsAndResolvers: "always",
        loadChildren: () =>
          import("./recordingRules/recording-rules.modules").then(m => m.ExternalSipAddressModule)
      },
      {
        path: "external-phone-number",
        data: { title: "External Phone Number" },
        runGuardsAndResolvers: "always",
        loadChildren: () =>
          import("./externalPhoneNumber/external-phone-number.module").then(
            m => m.ExternalPhoneNumberModule
          )
      },
      {
        path: "conference-suite",
        data: { title: "Conference Suite" },
        runGuardsAndResolvers: "always",
        loadChildren: () =>
          import("./conferenceSuite/adv-conference-suite.module").then(
            m => m.AdvConferenceSuiteModule
          )
      }
    ]
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)]
})
export class AdministratorsRoutingModule {}
